import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can merge issues representing the same problem from the issue list by:`}</p>
    <ol>
      <li parentName="ol">{`Selecting the primary issue others should be merged into`}</li>
      <li parentName="ol">{`Selecting the issue(s) to merge into the primary issue`}</li>
      <li parentName="ol">{`Clicking the `}<strong parentName="li">{`Merge`}</strong>{` button`}</li>
    </ol>
    <p>{`After merging, all events and aggregated counts from the merged issues are added to the primary issue. The merged issues are then deleted (but the underlying events are not).`}</p>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/merge_light_0489da02c6.png" imageDark="https://res.cloudinary.com/dmukukwp6/image/upload/merge_dark_aab4bfcc93.png" alt="Error tracking issue merging" classes="rounded" mdxType="ProductScreenshot" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      